import NextWrapper from '@/components/layouts/Containers/NextWrapper/NextWrapper';
import { Contacts } from '@/reactPages/Contacts';

export const meta = {
  title: 'Контакты',
  description:
    'Сахалинское ипотечное агентство - это сервис, помогающий найти лучшее предложение на рынке недвижимости Сахалинской области.',
  keywords: 'Сахалинское ипотечное агентство, помощь, о нас',
};

const Page = () => {
  return (
    <>
      <NextWrapper meta={meta}></NextWrapper>
      <Contacts></Contacts>
    </>
  );
};

export default Page;
